import { BasicTimePicker, TimePickerProps } from '@lfg/ui/components';
import { Box, Typography } from '@mui/material';
import type { CSSProperties, ElementType } from 'react';

import { colors } from 'src/global/styles/colors';

export interface TimePicker extends Omit<TimePickerProps, 'onChange' | 'value'> {
  placeholder?: string;
  style?: CSSProperties;
  suffixIcon?: ElementType<any, keyof React.JSX.IntrinsicElements>;
  onChange?: (val: Date | null) => void;
  readOnly?: boolean;
  value?: TimePickerProps['value'];
  isError?: boolean;
  errorMsg?: string;
  isHideHint?: boolean;
}

const TimePicker = (props: TimePicker) => {
  const {
    isHideHint = false,
    errorMsg,
    placeholder,
    value,
    onChange = () => {},
    readOnly = false,
    style,
    isError,
    sx,
    ...rest
  } = props;
  return (
    <Box>
      <BasicTimePicker
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            color: 'white',
            '& fieldset': {
              borderColor: `${isError ? colors.error : colors.neutral015} !important`,
            },
            '&:hover fieldset': {
              borderColor: `white !important`,
            },
            '&.Mui-focused fieldset': {
              borderColor: 'white',
            },
            '& fieldset.MuiOutlinedInput-notchedOutline': {
              borderColor: colors.neutral015,
            },
          },
          '& .MuiInputLabel-root': {
            color: 'white',
          },
          '& .MuiSvgIcon-root': {
            color: 'white',
          },
          ...sx,
        }}
        readOnly={readOnly}
        onChange={onChange}
        value={value}
        {...rest}
      />
      {isHideHint ? null : (
        <Typography paddingTop={0.5} color={colors.neutral300} fontSize={'12px'} fontStyle={'italic'}>
          * Time displayed in your current time zone
        </Typography>
      )}
      {isError ? (
        <Typography paddingTop={1} color={colors.error} fontSize={'14px'}>
          {errorMsg}
        </Typography>
      ) : null}
    </Box>
  );
};

export default TimePicker;
